import React from 'react'
import { css } from '@emotion/core'

export const DetailCard: React.FC = props => {
  return <div css={cardContainerStyle}>{props.children}</div>
}

export const DetailCardTitle: React.FC = props => {
  return <div css={cardTitleStyle}>{props.children}</div>
}

const cardContainerStyle = css({
  background: '#FFFFFF',
  boxShadow: '0px 0px 6px #0000001A',
  border: '1px solid #F2F2F2',
  borderRadius: 5,
})

const cardTitleStyle = css({
  display: 'flex',
  alignItems: 'center',
  height: 50,
  fontSize: 18,
  fontWeight: 'bold',
  padding: '0 32px',
  justifyContent: 'space-between',
})
